export default function Stamp({ size = 160, light = false, spin = true, className = "" }) {
  const ink = light ? "#FAF6EE" : "#1C1512";
  const id = light ? "stamp-light" : "stamp-dark";
  return (
    <div
      className={`relative select-none ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 200 200"
        className={`w-full h-full ${spin ? "animate-spin-slow" : ""}`}
      >
        <defs>
          <path
            id={id}
            d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0"
            fill="none"
          />
        </defs>
        <text fill={ink} fontSize="15" fontFamily="JetBrains Mono, monospace" fontWeight="500">
          <textPath href={`#${id}`} textLength="500">
            ZONI&apos;S BAKEHOUSE ✶ DADAR ✶ MUMBAI ✶ SMALL BATCH ✶
          </textPath>
        </text>
        <circle cx="100" cy="100" r="62" fill="none" stroke={ink} strokeWidth="1.5" />
      </svg>
      <div
        className="absolute inset-0 flex flex-col items-center justify-center"
        style={{ color: ink }}
      >
        <span
          className="font-display italic font-bold leading-none"
          style={{ fontSize: size * 0.21 }}
        >
          Zoni&apos;s
        </span>
        <span
          className="font-mono uppercase tracking-[0.3em]"
          style={{ fontSize: size * 0.055, marginTop: size * 0.05 }}
        >
          Bakehouse
        </span>
      </div>
    </div>
  );
}
